import React, { useEffect, useRef, useState } from 'react';
import '../styles/gallery.css';

const photos = [
  { src: '/gallery/clinic-1.jpg', alt: 'Clinic space' },
  { src: '/gallery/clinic-2.jpg', alt: 'Clinic space' },
  { src: '/gallery/clinic-3.jpg', alt: 'Clinic space' },
  { src: '/gallery/clinic-4.jpg', alt: 'Clinic space' },
  { src: '/gallery/clinic-5.jpg', alt: 'Clinic space' },
  { src: '/gallery/clinic-6.jpg', alt: 'Clinic space' },
  { src: '/gallery/clinic-7.jpg', alt: 'Clinic space' },
];

const Gallery = () => {
  const sectionRef = useRef(null);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.1 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => el && observer.unobserve(el);
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (!lightbox) return;
      if (e.key === 'Escape') setLightbox(null);
      if (e.key === 'ArrowRight') setLightbox(i => (i + 1) % photos.length);
      if (e.key === 'ArrowLeft') setLightbox(i => (i - 1 + photos.length) % photos.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightbox]);

  return (
    <section className="gallery-section">
      <div className="container">
        <div className="section-header fade-up" ref={sectionRef}>
          <span className="section-tag">Our Clinic</span>
          <h2>A Space Built for Healing</h2>
          <p>Thoughtfully designed to feel calm, private, and welcoming from the moment you walk in.</p>
        </div>

        <div className="gallery-bento">
          {photos.map((photo, i) => (
            <div
              key={i}
              className={`gallery-item gallery-item-${i + 1}`}
              onClick={() => setLightbox(i)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setLightbox(i)}
              aria-label={`View ${photo.alt} ${i + 1}`}
            >
              <img src={photo.src} alt={photo.alt} loading="lazy" />
              <div className="gallery-overlay">
                <span className="gallery-zoom">&#x2B;</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightbox !== null && (
        <div className="gallery-lightbox" onClick={() => setLightbox(null)}>
          <button className="lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">&#x2715;</button>
          <button
            className="lightbox-nav lightbox-prev"
            onClick={(e) => { e.stopPropagation(); setLightbox(i => (i - 1 + photos.length) % photos.length); }}
            aria-label="Previous"
          >
            <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6" /></svg>
          </button>
          <img
            src={photos[lightbox].src}
            alt={photos[lightbox].alt}
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="lightbox-nav lightbox-next"
            onClick={(e) => { e.stopPropagation(); setLightbox(i => (i + 1) % photos.length); }}
            aria-label="Next"
          >
            <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6" /></svg>
          </button>
          <div className="lightbox-counter">{lightbox + 1} / {photos.length}</div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
